<script>
	import Header from './components/Header/Header.svelte';
	import ProductFeatures from './components/ProductFeatures/ProductFeatures.svelte';
	import OurBlog from './components/OurBlog/OurBlog.svelte';
	import GetInTouch from './components/GetInTouch/GetInTouch.svelte';
	import Footer from './components/Footer/Footer.svelte';
</script>

<main>
	<Header/>
	<ProductFeatures />
	<OurBlog/>
	<GetInTouch/>
	<Footer/>
</main>

